export const licenceMethods = {
  HOOK: 'hook',
  TSOFT_INTEGRATION: 'tsoft_integration',
  CONNECTPROF: 'connectprof',
  TAHSILDAR: 'tahsildar',
}
